import { delegateInit } from './BaseShape';
import { ReturnStatement } from './ReturnStatement';

const ENTITY_FIELD_NAME = 'CatchClause';

export default delegateInit(ReturnStatement, ENTITY_FIELD_NAME);



// WEBPACK FOOTER //
// ./src/render/svg/shapes/CatchClause.js